import Vue from 'vue'
import store from '@/modules/store'
import VueXI18n from 'vuex-i18n'

Vue.use(VueXI18n.plugin, store)
